import type { WhatsappGroupsTranslations } from '../interfaces/whatsappGroups';

export const whatsappGroupsTranslations: WhatsappGroupsTranslations = {
  page_title: 'Grupos do WhatsApp',
  page_subtitle:
    'Crie grupos no número da {{brand}}, compartilhe o link de convite e atribua um agente de IA a cada grupo (máx. 8 participantes).',
  new_group: 'Novo grupo',
  search_placeholder: 'Buscar por nome…',
  empty_title: 'Ainda não há grupos',
  empty_description:
    'Crie seu primeiro grupo do WhatsApp e compartilhe o link de convite.',
  members_badge: '{{count}}/8 membros',
  suspended_badge: 'Suspenso',
  agent_badge_active: 'Agente ativo',
  agent_badge_paused: 'Agente pausado',
  agent_badge_none: 'Sem agente',
  row_copy_link: 'Copiar link',
  row_view: 'Ver grupo',
  row_delete: 'Excluir',
  delete_confirm_title: 'Excluir grupo',
  delete_confirm_description:
    'O grupo será excluído no WhatsApp para todos os membros. Esta ação não pode ser desfeita.',
  delete_confirm_cta: 'Excluir',
  link_copied: 'Link copiado para a área de transferência',
  no_invite_link: 'Sem link de convite',

  create_title: 'Novo grupo',
  create_subtitle:
    'O grupo é criado no número verificado da {{brand}}. Os membros entram pelo link de convite.',
  form_subject_label: 'Nome do grupo',
  form_subject_placeholder: 'ex.: Clientes VIP',
  form_subject_required: 'O nome é obrigatório',
  form_subject_too_long: 'Máximo de 128 caracteres',
  form_description_label: 'Descrição',
  form_description_placeholder: 'Descrição opcional do grupo…',
  form_description_too_long: 'Máximo de 2048 caracteres',
  form_approval_label: 'Entrada no grupo',
  approval_required_label: 'Requer aprovação',
  approval_required_description:
    'Cada solicitação de entrada deve ser aprovada manualmente.',
  auto_approve_label: 'Entrada automática',
  auto_approve_description:
    'Quem tiver o link entra direto (até o grupo lotar).',
  form_agent_label: 'Agente de IA (opcional)',
  form_agent_placeholder: 'Selecione um agente…',
  form_agent_none: 'Sem agente',
  create_submit: 'Criar grupo',
  create_success: 'Grupo criado com sucesso',

  back_to_list: 'Voltar aos grupos',
  suspended_banner:
    'A Meta suspendeu este grupo. O agente não responderá e nenhuma alteração é possível até a suspensão ser retirada.',
  tab_members: 'Membros',
  tab_requests: 'Solicitações',
  tab_agent: 'Agente',
  tab_settings: 'Configurações',

  invite_title: 'Link de convite',
  invite_description:
    'Compartilhe com as pessoas que você quer no grupo. Só é possível entrar por este link.',
  invite_copy: 'Copiar',
  invite_reset: 'Gerar novo link',
  invite_reset_confirm_title: 'Gerar um novo link?',
  invite_reset_confirm_description:
    'O link atual deixará de funcionar. Você precisará compartilhar o novo.',

  members_title: 'Membros do grupo',
  members_empty: 'Ainda não há membros. Compartilhe o link de convite.',
  member_remove: 'Remover',
  member_remove_confirm_title: 'Remover do grupo',
  member_remove_confirm_description:
    'Esta pessoa sairá do grupo. Ela poderá voltar com um link de convite válido.',
  member_joined_at: 'Entrou em {{date}}',

  requests_title: 'Solicitações de entrada',
  requests_empty: 'Não há solicitações pendentes.',
  request_approve: 'Aprovar',
  request_reject: 'Rejeitar',
  request_status_pending: 'Pendente',
  request_status_approved: 'Aprovada',
  request_status_rejected: 'Rejeitada',
  request_status_revoked: 'Retirada',

  agent_title: 'Agente de IA',
  agent_description:
    'O agente atribuído responde automaticamente às mensagens deste grupo.',
  agent_select_placeholder: 'Selecione um agente…',
  agent_save: 'Salvar',
  agent_pause: 'Pausar',
  agent_resume: 'Retomar',
  agent_unbind: 'Remover agente',
  agent_unbind_confirm_title: 'Remover o agente deste grupo',
  agent_unbind_confirm_description:
    'O agente deixará de responder neste grupo. Você pode atribuir outro quando quiser.',
  agent_none_hint: 'Este grupo não tem agente atribuído.',

  settings_title: 'Configurações do grupo',
  settings_save: 'Salvar alterações',
  settings_delete_title: 'Excluir grupo',
  settings_delete_description:
    'Exclui o grupo no WhatsApp para todos os membros.',

  cancel: 'Cancelar',
  confirm: 'Confirmar',
  saved: 'Alterações salvas',
  error_generic: 'Algo deu errado. Tente novamente.',
};
